// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__O065u","btn":"Header_btn__f10bs"};